import { render } from "./MultiChoiceAnswer.vue?vue&type=template&id=48785230&scoped=true"
import script from "./MultiChoiceAnswer.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiChoiceAnswer.vue?vue&type=script&setup=true&lang=js"

import "./MultiChoiceAnswer.vue?vue&type=style&index=0&id=48785230&scoped=true&lang=css"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48785230"],['__file',"resources/js/modules/learning_module/components/question/MultiChoiceAnswer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48785230"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48785230', __exports__)) {
    api.reload('48785230', __exports__)
  }
  
  module.hot.accept("./MultiChoiceAnswer.vue?vue&type=template&id=48785230&scoped=true", () => {
    api.rerender('48785230', render)
  })

}


export default __exports__